import classNames from "classnames";
import React, { useCallback } from "react";

import BaseLink from "../BaseLink";
import config from "../../../../../../config";

function DesktopNavigationLink({
  href,
  label,
  children,
  onEnter,
  className,
  target,
  active,
  onClick
}: {
  onEnter?: ({
    children: any,
    event:
      | React.MouseEvent<HTMLButtonElement>
      | React.MouseEvent<HTMLLinkElement>
  }) => void,
  onLeave?: ({
    children: any,
    event:
      | React.MouseEvent<HTMLButtonElement>
      | React.MouseEvent<HTMLLinkElement>
  }) => void
}) {
  const handleEnter = useCallback(
    async ({ event }) => {
      if (typeof onEnter !== "function") return;
      event.stopPropagation();

      await onEnter({ event });
    },
    [onEnter]
  );

  return (
    <BaseLink
      onClick={onClick}
      href={href}
      label={label}
      children={children}
      onEnter={handleEnter}
      className={classNames("desktop-navigation__link", className, {
        "desktop-navigation__link_active": active
      })}
      labelClassName={classNames("desktop-navigation__label", {
        "desktop-navigation__label_new": config.newMenuItems.includes(label)
      })}
      target={target}
    />
  );
}

export default DesktopNavigationLink;
